import { Form, FormInstance, Radio, RadioChangeEvent } from 'antd'
import React from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { RollCallResp } from 'types/event/eventAttendance'

interface CreateRollCallProps {
  form: FormInstance
  setPayload: React.Dispatch<React.SetStateAction<any>>
  setCurrent: React.Dispatch<React.SetStateAction<number>>
}

const CreateRollCall: React.FC<CreateRollCallProps> = ({
  form,
  setPayload,
  setCurrent,
}) => {
  const { rollCallData }: { rollCallData: RollCallResp } = eventAttendanceStore(
    store => ({
      rollCallData: store.rollCallData,
    }),
  )

  const predefinedNames = ['Bathroom', 'Bus', 'Diaper change', 'Lunch', 'Snack']

  const formSchema = {
    name: rollCallData
      ? predefinedNames.includes(rollCallData.name)
        ? rollCallData.name
        : 'Other'
      : undefined,
    otherName: rollCallData ? rollCallData.name : undefined,
  }

  const onFinish = (values: any) => {
    const { name, otherName } = values
    setPayload({ name: name === 'Other' ? otherName : name })
    setCurrent(1)
  }

  return (
    <Form
      name="create-roll-call"
      form={form}
      initialValues={formSchema}
      onFinish={onFinish}
    >
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: 'Please select or enter a name',
          },
        ]}
      >
        <Radio.Group className="flex gap-20px flex-wrap">
          <Radio.Button value={'Bathroom'} className="w-130px radio-Button">
            Bathroom
          </Radio.Button>
          <Radio.Button value={'Bus'} className="w-130px radio-Button">
            Bus
          </Radio.Button>
          <Radio.Button
            value={'Diaper change'}
            className="w-130px radio-Button"
          >
            Diaper change
          </Radio.Button>
          <Radio.Button value={'Lunch'} className="w-130px radio-Button">
            Lunch
          </Radio.Button>
          <Radio.Button value={'Snack'} className="w-130px radio-Button">
            Snack
          </Radio.Button>
          <Radio.Button value={'Other'} className="w-130px radio-Button">
            Other
          </Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.name !== currentValues.name
        }
      >
        {({ getFieldValue }) =>
          getFieldValue('name') === 'Other' ? (
            <Form.Item
              name="otherName"
              rules={[
                {
                  required: true,
                  message: 'Please enter a name',
                },
              ]}
            >
              <input className="w-80p my-input mt-20px" />
            </Form.Item>
          ) : null
        }
      </Form.Item>
    </Form>
  )
}

export default CreateRollCall
